// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `div.reminder-header {
  display: flex;
  justify-content: space-between;
  color: var(--ion-color-medium);
  margin: 20px 16px 0;
  font-size: 12px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/shared/reminder-list/reminder-list.component.scss"],"names":[],"mappings":"AAAA;EACC,aAAA;EACA,8BAAA;EACA,8BAAA;EACA,mBAAA;EACA,eAAA;AACD","sourcesContent":["div.reminder-header {\r\n\tdisplay: flex;\r\n\tjustify-content: space-between;\r\n\tcolor: var(--ion-color-medium);\r\n\tmargin: 20px 16px 0;\r\n\tfont-size: 12px;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
